import httpClient from '../httpClient';

const getProjectsActive = async () => {
  return await httpClient.get(`persons_search/active-projects/`);
};

const getCharges = async (idProject) => {
  return await httpClient.get(`persons_search/charges/${idProject}/`);
};

const ajaxTableUsers = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/persons_search/active-users/?page[number]=${page}&page[size]=${pageSize}&${query}${sortBy}${searchBy}`,
  );
};


const ajaxTablePersons = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/persons/?page[number]=${page}&page[size]=${pageSize}&${query}${sortBy}${searchBy}`,
  );
};

const createPersons = async (data) => {
  return await httpClient.post(`persons/`, { data: data });
}

const deactivatePersons = async (id) => {
  return await httpClient.patch(`persons/${id}/deactivate/`);
}

export {
  getProjectsActive,
  ajaxTablePersons,
  getCharges,
  ajaxTableUsers,
  createPersons,
  deactivatePersons,
};
